module.exports = __webpack_public_path__ + "assets/img/slogan-feb681c4.png";